import { safeParseNullDefault } from 'shouldve-been-js';

class Tenant {

    private _tenantId: string;
    private _displayName: string;

    public constructor(tenantId: string, displayName: string) {

        this._tenantId = tenantId;
        this._displayName = displayName;
    }

    public get tenantId(): string {
        return this._tenantId;
    }

    public set tenantId(value: string) {
        this._tenantId = value;
    }

    public get displayName(): string {
        return this._displayName;
    }

    public set displayName(value: string) {
        this._displayName = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Tenant | null {

        const tenantId: string | null = safeParseNullDefault<string>(json?.tenantId, '');
        const displayName: string | null = safeParseNullDefault<string>(json?.displayName, '');

        if (tenantId === null || displayName === null) {
            return null;
        }

        return new Tenant(tenantId, displayName);
    }
}

export default Tenant;